module.exports = __webpack_public_path__ + "img/backArrow.826a48b0.svg";